import { DEFAULT_TEMPLATE_RESOLUTION } from 'modules/manager/domain/template-resolutions';
import React from 'react';

interface RenderPreviewSkeletonProps {
  /** Размер шаблона — сервер отдаёт картинку ровно такого размера. */
  width?: number;
  height?: number;
}

/**
 * Плашка на месте картинки серверного рендера, пока она не пришла.
 *
 * Картинка в модалке — `mx-auto max-h-[60vh] rounded-card` с натуральным размером
 * шаблона, то есть её ширина — `min(ширина тела, ширина шаблона, 60vh · w/h)`, а высота
 * следует пропорции. Плашка считает ту же ширину сама, поэтому пришедшая картинка
 * встаёт ровно на её место и модалка не меняет высоту.
 */
export const RenderPreviewSkeleton: React.FC<RenderPreviewSkeletonProps> = ({
  width = DEFAULT_TEMPLATE_RESOLUTION.width,
  height = DEFAULT_TEMPLATE_RESOLUTION.height,
}) => {
  const aspectRatio = `${width} / ${height}`;

  return (
    <div
      className="skeleton-block rounded-card mx-auto"
      style={{ width: `min(100%, ${width}px, 60vh * ${width / height})`, aspectRatio }}
      // jsdom не знает `aspect-ratio` и выбрасывает его из `style` — тест читает пропорцию отсюда.
      data-aspect-ratio={aspectRatio}
      data-testid="render-preview-skeleton"
      aria-hidden
    />
  );
};

export default RenderPreviewSkeleton;
